import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Chart } from 'chart.js/auto';
import axios from 'axios';
import config from '../config'

const RevenueVsEarningsChart = ({ symbol }) => {
  const canvasRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    const fetchChartData = async () => {
      try {
        const res = await axios.get(`${config.backendUrl}/api/markets/stock-revenue-vs-earnings?ticker=${symbol}`);
        const labels = res.data.data.map(item => item.label);
        const revenueData = res.data.data.map(item => item.revenue);
        const earningsData = res.data.data.map(item => item.earnings);

        if (chartRef.current) {
          chartRef.current.destroy(); // destroy old chart
        }

        chartRef.current = new Chart(canvasRef.current, {
          type: 'bar',
          data: {
            labels,
            datasets: [
              {
                label: 'Revenue',
                data: revenueData,
                backgroundColor: 'rgba(243, 8, 181, 1)',
                barThickness: 8,
                borderRadius: 5
              },
              {
                label: 'Earnings',
                data: earningsData,
                backgroundColor: 'rgb(2,255,0)',
                barThickness: 8,
                borderRadius: 5
              }
            ]
          },
          options: {
            responsive: true,
            plugins: {
                title: {
                  display: true,
                  text: 'Revenue vs Earnings',
                  font: { size: 18 },
                  color: 'white'
                },
                legend: { position: 'top' }
              },
            scales: {
              y: {
                beginAtZero: true,
                title: { display: true, text: 'Value (in millions)' }
              }
            }
          }
        });
      } catch (err) {
        console.error('Error fetching revenue vs earnings data', err);
      }
    };

    fetchChartData();

    return () => {
      if (chartRef.current) chartRef.current.destroy();
    };
  }, [symbol]);

  return <canvas ref={canvasRef} />;
};

RevenueVsEarningsChart.propTypes = {
    symbol: PropTypes.string.isRequired
};

export default RevenueVsEarningsChart;
